module.exports = __webpack_public_path__ + "img/title.c96af9db.svg";